module.exports = __webpack_public_path__ + "img/daiqueren.2716108c.png";